export const photoEditorInitData = {
  type: "root",
  children: [
    {
      type: "paragraph",
      children: [
        {
          text:
            "Web 上での表現の写真のレイアウト、というのはまだまだ議論がされていないように思えます。これは、画面サイズが不特定、というデバイスにおいて、どのような見せ方がベストなのか検討するのが難しいことも一つの大きな要因でしょう。"
        },
        {
          text: "-"
        }
      ]
    },
    {
      type: "images",
      layout: "Justify",
      images: [
        {
          type: "picsum",
          id: "adfluecca",
          originalUrl: "https://picsum.photos/id/257/800/600.jpg",
          originalWidth: 800,
          originalHeight: 600
        },
        {
          type: "picsum",
          id: "aluaa",
          originalUrl: "https://picsum.photos/id/258/600/480.jpg",
          originalWidth: 600,
          originalHeight: 480
        },
        {
          type: "picsum",
          id: "aljevaa",
          originalUrl: "https://picsum.photos/id/259/800/600.jpg",
          originalWidth: 800,
          originalHeight: 600
        },
        {
          type: "picsum",
          id: "moenadfjh",
          originalUrl: "https://picsum.photos/id/260/800/600.jpg",
          originalWidth: 800,
          originalHeight: 600
        },
        {
          type: "picsum",
          id: "Maluaa",
          originalUrl: "https://picsum.photos/id/158/600/480.jpg",
          originalWidth: 600,
          originalHeight: 480
        },
        {
          type: "picsum",
          id: "3aljevaa",
          originalUrl: "https://picsum.photos/id/159/800/600.jpg",
          originalWidth: 800,
          originalHeight: 600
        }
      ],
      children: [{ text: "" }]
    },
    {
      type: "paragraph",
      children: [
        {
          text:
            "また、PC やスマートフォン、異なるデバイスにおいての表現の仕方も大きく異なります。そのため、どうしても画面の中央に一つの写真、というレイアウトになりがちです。固定されたレイアウト表現、例えば雑誌での写真レイアウト、というのはパターンがある程度決まっていますが、PCやスマートフォンを包括してのレイアウト、というのは未だに決まりがないように思えます。"
        }
      ]
    },
    {
      type: "images",
      layout: "TwoRows",
      images: [
        {
          type: "picsum",
          id: "adfDluecca",
          originalUrl: "https://picsum.photos/id/157/800/600.jpg",
          originalWidth: 800,
          originalHeight: 600
        },
        {
          type: "picsum",
          id: "Maluaaadf",
          originalUrl: "https://picsum.photos/id/58/600/480.jpg",
          originalWidth: 600,
          originalHeight: 480
        },
        {
          type: "picsum",
          id: "Maluaaaeeeaadf",
          originalUrl: "https://picsum.photos/id/57/600/480.jpg",
          originalWidth: 600,
          originalHeight: 480
        }
      ],
      children: [{ text: "" }]
    },
    {
      type: "paragraph",
      children: [
        {
          text:
            "Instagram、いま世界で最も使われている写真表示アプリでは、ある程度レイアウトを固定することによって、統一性をもたせています。"
        }
      ]
    }
  ]
}
